export default __webpack_public_path__ + "static/home2-aea2b8ca59e3991891201569f503665f.png";